import React from 'react';
import NavBar from '../../Components/NavBar/NavBar';

const AppMenu = () => {
  return (
      <NavBar className=" bg-antique fixed left-0 top-0 w-full h-full z-70" />
  )
}

export default AppMenu
